module.exports = __webpack_public_path__ + "img/sidebar-affiliate.bcdd5fd.svg";